@for (node of nodes; track node) {
  <button
    [ngClass]="(selectedTag | async) && (selectedTag | async).tag === node.data.tag && 'active'"
    [style.padding]="'10px 20px 10px ' + (shift + 20) + 'px'"
    [style.color]="node.data.disabled ? 'darkgray' : null"
    (click)="handleClick(node.data)"
    >
    @if (node.data.scope === 'Location') {
      <emm-icon symbol="square"></emm-icon>
    }
    @if (node.data.scope !== 'Location' && nodeSelected[node.data.tag]) {
      <emm-icon symbol="down"></emm-icon>
    }
    @if (node.data.scope !== 'Location' && !nodeSelected[node.data.tag]) {
      <emm-icon symbol="right"></emm-icon>
    }
    {{ node.data.name }}
  </button>
  @if (loading[node.data.tag]) {
    <div
      [style.padding]="'10px 20px 10px ' + (shift + 40) + 'px'"
      >
      Loading...
    </div>
  }
  @if (childrenNodes[node.data.tag] && childrenNodes[node.data.tag].length) {
    <emm-nutrition-assignments-location-sets-list
      [nodes]="childrenNodes[node.data.tag]"
      [shift]="shift + 20"
    ></emm-nutrition-assignments-location-sets-list>
  }
}
